<div style="padding:30px">
    <input type="text" [(ngModel)]="search_model" (keyup.enter)="init_list()" class="form-control" style="width: 240px;display:inline-block" placeholder="請輸入想搜尋的人名後點enter">
    <select class="form-control" style="width: 120px;display: inline-block;" [(ngModel)]="search_type" (change)="init_list()">
        <option default disabled>請選擇搜尋的類型</option>
        <option *ngFor="let item of option_list" [ngValue]="item.id">{{item.name}}</option>
    </select>
    <button *ngIf="search_type==='1'"   class="btn btn-primary" (click)="patch(1)" data-toggle="modal" data-target=".bd-example-modal-xl">批次處理</button>
    <a *ngIf="['1', '2'].includes(search_type)"  href="{{urltoken}}" target="_blank"  class="btn btn-success">匯出資料</a>
    <a *ngIf="['1', '2'].includes(search_type)"  href="{{urltoken2}}" target="_blank"  class="btn btn-success">勞報單</a>
    <app-date [time]="time" [type]="true" [timeset]="timeset" (rangeSelected)="handleRangeSelectedacc($event)"></app-date>

    <!-- <a *ngIf="search_type==='2'" href="{{urltoken2}}" target="_blank"  class="btn btn-danger">匯出資料(不分)</a> -->
    <!-- <button *ngIf="search_type==='2'"  (click)="success()"  class="btn btn-primary">全部改為已匯款</button>-->
    <div class="sys-hint">
        <div class="sys-hint-title">📊 勞報單資料判斷說明</div>
        <div class="sys-hint-text">
            勞報單統計依「建立時間」為主要依據，<br>
            本頁查詢則以「最後修改時間」進行篩選。<br><br>
            <b>建議查詢時：</b><br>
            請讓時間選擇器同時涵蓋建立時間與修改時間區間，<br>
            以避免資料遺漏或落差。
        </div>
    </div>
    <div style="text-align: left;margin:10px;font-size: 16px;">總金額:{{money|number}}</div>
    <table style="margin-top: 10px;"  class="table table-responsive-sm" *ngIf="data.length>0">
        <thead>
            <tr class="table-primary" style="font-size:18px;">
                <th  *ngIf="search_type=='1'"><input type="checkbox"  [checked]="all_check" (change)="all_check = !all_check;check_it(all_check)" style="margin-right: 8px;">全選</th>
                <th>申請者</th>
                <th>本名</th>
                <th>戶名</th>
                <th>KYC審核</th>
                <th>銀行審核</th>
                <th>帳戶狀態</th>
                <th>扣除鑽石</th>
                <th>申請金額</th>
                <th >本次兌換比率</th>
                <th >狀態</th>
                <th >統編</th>
                <th >訊息</th>
                <th >建立時間</th>
                <th >修改時間</th>
                <th  *ngIf="search_type=='1'" >操作</th>
            </tr>
        </thead>

        <tbody>
            <tr *ngFor="let item of data; let i = index" class="{(index % 2 ==0)?'table-secondary':'table-light'}">
                <td  *ngIf="search_type=='1'"><input type="checkbox" [(ngModel)]="item.checked"></td>
                <td>
                    <app-userandactive  [post]="item"></app-userandactive>
                </td>
                <td>
                    <a target="_blank" href="{{link}}/user/{{item.uid}}">
                        <span>
                            {{item.id_name}}
                        </span>
                    </a>
                </td>
                <td>{{item.bank_accountname}}</td>
                <td>{{item.kycstatus}}</td>
                <td>{{item.bankstatus}}</td>
                <td>{{item.is_enable}}</td>
                <td>{{item.diamon|number}}</td>
                <td>{{item.money|number}}</td>
                <td>{{item.rate}}</td>
                <td>{{banktransfer_status[item.status]}}</td>
                <td>{{item.tax_id_num}}</td>
                <td>{{item.msg}}</td>
                <td>{{item.create_dt}}</td>
                <td>{{item.update_dt}}</td>
                <td  *ngIf="search_type=='1'"><button (click)="edit(item)"  class="btn btn-danger" data-toggle="modal" data-target=".bd-example-modal-xl">處理</button></td>
            </tr>
        </tbody>
    </table>
    <app-pagnation (callback)="callback($event)" [data]="pageobjstr"></app-pagnation>
    <div *ngIf="data.length==0">無資料</div>
</div>

<div  *ngIf="edit_data" class="modal fade bd-example-modal-xl" tabindex="-1" role="dialog"  data-keyboard="false" data-backdrop="static" aria-labelledby="myExtraLargeModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-xl">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">審核</h4>
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>

            <div class="modal-body">
                <div class="subtitle">審核結果:</div>
                <div class="subitem">
                    <button [ngClass]="edit_data.status==1?'btn-danger':'btn-secondary'" (click)="edit_data.status=1" class="btn">審核中</button>
                    <button [ngClass]="edit_data.status==2?'btn-danger':'btn-secondary'" (click)="edit_data.status=2" class="btn">審核批准</button>
                    <button [ngClass]="edit_data.status==-2?'btn-danger':'btn-secondary'" (click)="edit_data.status=-2" class="btn">審核拒絕</button>
                </div>
                <div class="subtitle">回復訊息:</div>
                <div class="subitem"><textarea style="min-height: 120px;" placeholder="{{edit_data.status*1==-2?'因為資料不齊全所以審核拒絕':''}}"  [(ngModel)]="edit_data.msg" class="form-control"></textarea></div>
            </div>

            <div class="modal-footer">
                <button type="button"  (click)="save()"  class="btn btn-primary" data-dismiss="modal">確認</button>
                <button type="button"  (click)="init_list()" class="btn btn-danger" data-dismiss="modal">取消</button>
            </div>
        </div>
    </div>
</div>
<app-spinner [loading]="loading"></app-spinner>
